import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ConfigOptions, ConfigService } from '@wilson/config';
import { WithTranslations } from '@wilson/interfaces';
import { Observable } from 'rxjs';

export interface ExternalExtension extends WithTranslations {
  id: string;
  name: string;
  url: string;
  icon: string;
  organizationalUnitId: string;
}

@Injectable({
  providedIn: 'root',
})
export class ExternalExtensionsGateway {
  private readonly httpClient = inject(HttpClient);
  private readonly config = inject<ConfigOptions>(ConfigService);

  getExternalExtensions(): Observable<ExternalExtension[]> {
    return this.httpClient.get<ExternalExtension[]>(
      `${this.config.host}/external-extensions`,
    );
  }
}
